<template>
	<div class="restDay">

		<el-row type="flex" class="row-bg" justify="center">
			<el-col :xs="5" :sm="2" :md="2" :lg="2" :xl="2">
				<div class="title">
					事务标题
				</div>
			</el-col>
			<el-col :xs="19" :sm="10" :md="10" :lg="10" :xl="10">
				<div class="block">
					<el-input v-model="restDayData.title" placeholder="请输入内容"></el-input>
				</div>
			</el-col>
		</el-row>

		<el-row type="flex" class="row-bg" justify="center">
			<el-col :xs="5" :sm="2" :md="2" :lg="2" :xl="2">
				<div class="title">
					事务类型
				</div>
			</el-col>
			<el-col :xs="19" :sm="10" :md="10" :lg="10" :xl="10">
				<div class="block">
					<el-select v-model="restDayData.type" placeholder="请选择">
						<el-option v-for="item in type" :key="item" :label="item" :value="item">
						</el-option>
					</el-select>
				</div>
			</el-col>
		</el-row>
		<el-row type="flex" class="row-bg row-bg-1" justify="center">
			<el-col :xs="5" :sm="2" :md="2" :lg="2" :xl="2">
				<div class="title">
					事务年份
				</div>
			</el-col>
			<el-col :xs="19" :sm="10" :md="10" :lg="10" :xl="10">
				<div class="block">
					<el-date-picker :clearable="false" v-model="restDayData.year" @change="setDefauleYear" type="year" format="yyyy"
					 value-format="yyyy">
					</el-date-picker>
				</div>
			</el-col>
		</el-row>

		<el-row type="flex" class="row-bg row-bg-1" justify="center">
			<el-col :xs="5" :sm="2" :md="2" :lg="2" :xl="2">
				<div class="title">
					开始时间
				</div>
			</el-col>
			<el-col :xs="19" :sm="10" :md="10" :lg="10" :xl="10">
				<div class="block">
					<el-date-picker :clearable="false" v-model="restDayData.startTime" type="date" format="MM-dd" value-format="yyyy-MM-dd">
					</el-date-picker>
				</div>
			</el-col>
		</el-row>

		<el-row type="flex" class="row-bg row-bg-1" justify="center">
			<el-col :xs="5" :sm="2" :md="2" :lg="2" :xl="2">
				<div class="title">
					结束时间
				</div>
			</el-col>
			<el-col :xs="19" :sm="10" :md="10" :lg="10" :xl="10">
				<div class="block">
					<el-date-picker :clearable="false" v-model="restDayData.endTime" type="date" format="MM-dd" value-format="yyyy-MM-dd">
					</el-date-picker>
				</div>
			</el-col>
		</el-row>

		<el-row type="flex" class="row-bg row-bg-2 row-bg-1" justify="center">
			<el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
				<el-button type="primary" @click="createRestDay">新建休息日</el-button>
			</el-col>
			<el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
				<el-button type="danger" @click="setDefaultData">重置</el-button>
			</el-col>
		</el-row>


		<el-row type="flex" class="row-bg row-bg-2 row-bg-1" justify="center">
			<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
				<div class="block">
					<el-input v-model="queryData.title" placeholder="事务标题"></el-input>
				</div>
			</el-col>
		</el-row>
		<el-row type="flex" class="row-bg row-bg-2 row-bg-1" justify="center">
			<el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
				<div class="block">
					<el-select v-model="queryData.type" placeholder="事务类型">
						<el-option v-for="item in type" :key="item" :label="item" :value="item">
						</el-option>
					</el-select>
				</div>
			</el-col>
			<el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
				<div class="block">
					<el-select v-model="queryData.year" placeholder="事务年份">
						<el-option v-for="item in years" :key="item" :label="item" :value="item">
						</el-option>
					</el-select>
				</div>
			</el-col>
		</el-row>

		<el-row type="flex" class="row-bg row-bg-2 row-bg-1" justify="center">
			<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
				<div class="block">
					<el-button type="primary" @click="searchHoliday">搜索</el-button>
				</div>
			</el-col>
		</el-row>

		<el-row type="flex" class="row-bg" justify="center">
			<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
				<el-table :data="tableData" style="width: 100%" :default-sort="{prop: 'year', order: 'descending'}">
					<el-table-column prop="year" label="年份" sortable>
					</el-table-column>
					<el-table-column prop="title" label="事务">
					</el-table-column>
					<el-table-column prop="type" label="事务类型">
					</el-table-column>
					<el-table-column prop="startTime" label="开始时间">
					</el-table-column>
					<el-table-column prop="endTime" label="结束时间">
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button size="mini" type="danger" @click="delRestDay(scope.$index, scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>

		<el-row type="flex" class="row-bg" justify="center">
			<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
				<div class="block center">
					<el-pagination :pager-count="5" @current-change="handleCurrentChange" :current-page="pageNumber+1" :page-size="20"
					 layout="prev, pager, next" :total="totalElements">
					</el-pagination>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import getHolidaylist, {
		addHoliday,
		delHoliday,
		getHolidayPost,
		getHolidayGet,
		getDefauleData
	} from '@/api/holiday'
	export default {
		data() {
			return {
				restDayData: {
					title: "",
					year: "",
					startTime: '',
					endTime: '',
					type: ''
				},
				tableData: [],
				type: [null],
				totalElements: 0,
				queryData: {
					title: '',
					year: null,
					type: null
				},
				years: [null],
				pageSize: null,
				pageNumber: 0,
			}
		},
		methods: {
			// 检索数据汇总方法
			getTableData(pageSize, pageNumber, queryData) {
				let that = this;
				getHolidayPost(pageSize, pageNumber, queryData).then(res => {
					that.tableData = res.data.content
					that.totalElements = res.data.totalElements
				})
			},
			// 设置默认年份
			setDefauleYear(e) {
				let now = new Date();
				let year = e;
				let MM = now.getMonth() < 10 ? "0" + (now.getMonth() + 1) : now.getMonth();
				let dd = now.getDate() < 10 ? "0" + (now.getDate()) : now.getDate();
				let nowtime = year + "-" + MM + "-" + dd;
				this.restDayData.endTime = nowtime;
				this.restDayData.startTime = nowtime;
			},
			// 数据检索
			searchHoliday() {
				this.pageNumber = 0;
				this.getTableData(this.pageSize, this.pageNumber, this.queryData);
			},
			// 排序
			order(e) {
				console.log("排序", e)
			},
			// 页码改变时
			handleCurrentChange(val) {
				this.pageNumber = val - 1;
				this.getTableData(this.pageSize, this.pageNumber, this.queryData);
			},
			// 设置初始时间
			setDefaultTime() {
				let now = new Date();
				let year = now.getFullYear();
				this.restDayData.year = JSON.stringify(year);

				let MM = now.getMonth() < 10 ? "0" + (now.getMonth() + 1) : now.getMonth();
				let dd = now.getDate() < 10 ? "0" + (now.getDate()) : now.getDate();
				let nowtime = year + "-" + MM + "-" + dd;
				this.restDayData.endTime = nowtime;
				this.restDayData.startTime = nowtime;
			},
			// 重置
			setDefaultData() {
				let that = this;
				getDefauleData(0).then(res => {
					that.type = res.data.typeOption;
					that.restDayData.type = res.data.type;
				})
				this.restDayData.title = "";
				this.setDefaultTime();
			},
			// 新建休息日
			createRestDay() {
				if (!this.restDayData.title || this.restDayData.startTime > this.restDayData.endTime) {
					const h = this.$createElement;
					this.$message({
						message: h('p', {
							style: "max-width:90%"
						}, [
							h('span', null, '事务标题不能为空且开始时间必须小于结束时间')
						]),
						type: "error"
					});
				} else {
					let that = this;
					addHoliday(this.restDayData).then(function(res) {
						let msg = res.data.msg
						if (res.data.success) {
							getHolidaylist().then((res) => {
								that.tableData = res.data.content
								that.$message({
									type: 'success',
									message: msg
								});
								that.setDefaultData();
							});
						} else {
							that.$message({
								type: 'error',
								message: msg
							});
						}
					})
				}
			},
			// 删除休息日
			delRestDay(index, row) {
				console.log(row)
				let that = this;

				const h = this.$createElement;
				this.$msgbox({
						title: "提示！",
						message: h('div', null, [
							h('p', null, '确定删除：'),
							h('p', null, '年份：' + row.year),
							h('p', null, '事务名称：' + row.title),
							h('p', null, '事务类型：' + row.type),
							h('p', null, '开始时间：' + row.startTime),
							h('p', null, '结束时间：' + row.endTime),
							h('p', null, '这条数据吗？')
						]),
					})
					.then(() => {
						delHoliday(row.id).then((res) => {
							if (res.status == "200") {
								getHolidaylist().then((res) => {
									that.tableData = res.data.content
								});
								that.$message({
									type: 'success',
									message: '删除成功!'
								});
							}
						})
					})
			},
		},
		mounted() {
			this.setDefaultTime();
			let that = this;
			getDefauleData(0).then(res => {
				that.type = res.data.typeOption;
				that.restDayData.type = res.data.type;
			})
			getHolidaylist(this.pageSize, this.pageNumber).then((res) => {
				that.tableData = res.data.content
				that.totalElements = res.data.totalElements
				that.pageSize = res.data.pageable.pageSize
			});
			let now = new Date();
			let nowYear = now.getFullYear();
			for (let i = 0; i < 5; i++) {
				this.years.push(nowYear - 3 + i);
			}
		},
	}
</script>

<style scoped="scoped">
	.restDay {
		padding: 0 20px;
		text-align: left;
	}

	.row-bg-1 {
		margin-top: -10px;
	}

	.row-bg-2 {
		text-align: center;
	}

	.title {
		line-height: 40px;
	}

	.center {
		text-align: center;
	}

	.el-picker-panel {
		left: 10%;
	}
</style>
